var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37546 6.63139C5.37546 7.00202 5.65512 7.30246 6.00012 7.30246C6.34511 7.30246 6.62477 7.00202 6.62477 6.63139V4.61816C6.62477 4.24753 6.34511 3.94708 6.00012 3.94708C5.65512 3.94708 5.37546 4.24753 5.37546 4.61816V6.63139ZM6.62477 8.6371C6.62477 8.26647 6.34511 7.96602 6.00012 7.96602C5.65512 7.96602 5.37546 8.26647 5.37546 8.6371V8.64462C5.37546 9.01525 5.65512 9.31569 6.00012 9.31569C6.34511 9.31569 6.62477 9.01525 6.62477 8.64462V8.6371ZM4.36186 1.03552C5.07588 -0.345173 6.92417 -0.345173 7.63815 1.03552L11.7615 9.00908C12.4554 10.351 11.5522 12 10.1233 12H1.87667C0.447792 12 -0.455399 10.351 0.238519 9.00908L4.36186 1.03552Z",
    fill: "#FEB91E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector7);
export default __webpack_public_path__ + "static/media/Vector (7).29b4f1bce31dbf6c979bf31ff2e9983e.svg";
export { ForwardRef as ReactComponent };